import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import Link from '@material-ui/core/Link';
import I18n from './I18n';

const useStyles = makeStyles(theme => ({
  root: {
	padding: theme.spacing(3),
	backgroundColor: grey[200]
  },
  hr: {
	height: '1px',
 	background: grey[500],
    border: '0px',
    margin: theme.spacing(2, 0, 2, 0)
  },
  contact: {
	marginLeft: theme.spacing(2),
	marginRight: theme.spacing(6)
  },
  email: {
	marginTop: theme.spacing(2)
  },
  info1: {
	color: grey[500],
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'flex-end',
	justifyContent: 'center'
  },
  info2: {
	color: grey[500],
	lineHeight: 1.1,
	marginBottom: '5px'
  },
  info3: {
	color: grey[500],
	lineHeight: 1.1
  }
}));

const Footer = () => {
  const classes = useStyles();
  return (
	<div className={classes.root}>
		<Typography className={classes.info1} variant='body1' align='center' wrap='wrap'>
			<span>
				<img
					className={classes.contact}
					src={'/logos/wechat2.png'}
					alt={'WeChat'}
					title={I18n('setting.contact2')}
					width={'85px'}
					height={'85px'}
				/>
            </span>
            <span>
				<img
					className={classes.contact}
					src={'/logos/wechat1.png'}
					alt={'Service'}
					title={I18n('setting.contact1')}
					width={'85px'}
					height={'85px'}
				/>
			</span>
			<span className={classes.email}>
				{I18n('setting.contact')}
			</span>
		</Typography>
		<hr className={classes.hr} />
		<Typography className={classes.info2} variant='body2' align='center'>
			{I18n('setting.copyright')}
		</Typography>
	    <Typography className={classes.info3} variant='body2' align='center'>
		    <Link href='http://beian.miit.gov.cn/' target='_blank' color={'inherit'} rel='noopener noreferrer'>
			    {I18n('setting.caseNumber')}
		    </Link>
			{I18n('setting.certificate')}
	    </Typography>
    </div>
  );
};

export default Footer;

